<template>
    <div class="push-animation position-relative">
        <div class="push-animation-img">
            <div v-if="pushAnimation.visual != null">
                <img class="fill-img" :src="pushAnimation.visual.src" :alt="pushAnimation.visual.alt">
            </div>
        </div>
        <div class="push-animation-text-block">
            <div class="push-animation-text-tile p-2" :class="pushAnimation.backgroundColor">
                <!--/* BANNIERE + TIMER */-->
                <div v-if="pushAnimationTimerBanner.tag" class="mb-1">
                    <tag-timer-banner
                        :banner="pushAnimationTimerBanner.tag"
                        :timer-end-date-in-milliseconds="pushAnimationTimerBanner.timerEndDateInMilliseconds"
                        :count-down-color="pushAnimationTimerBanner.timerCssClass"
                    />
                </div>
                <div
                    v-if="pushAnimation.title"
                    class="mb-0 h3"
                    v-html="pushAnimation.title"
                />
                <p
                    v-if="pushAnimation.text"
                    v-html="pushAnimation.text"
                />
                <p
                    v-if="pushAnimation.additionalText"
                    class="mb-2"
                    v-html="pushAnimation.additionalText"
                />
                <a
                    v-if="pushAnimation.url"
                    :href="pushAnimation.url"
                    :class="['btn btn-secondary mr-1 mb-1 mb-xl-0', { 'btn-inverse': isBackgroundDark}]"
                    :data-oevent-category="pushAnimation.buttonTms.category"
                    :data-oevent-action="pushAnimation.buttonTms.action"
                    :data-oevent-label="pushAnimation.buttonTms.label"
                >{{ pushAnimation.urlAccessWording }}</a>
            </div>
        </div>
    </div>
</template>

<script>
import TagTimerBanner from "../internet/showcase/components/TagTimerBanner.vue";

export default {
    name: 'PushAnimation',
    components: {TagTimerBanner},
    props: {
        pushAnimation: {type: Object, required: true}
    },
    computed: {
        pushAnimationTimerBanner() {
            return {
                tag: (this.pushAnimation.tag) ? this.pushAnimation.tag : undefined,
                timerEndDateInMilliseconds: (this.pushAnimation.timer) ? this.pushAnimation.timer.endDateInMilliseconds : undefined,
                timerCssClass: (this.pushAnimation.timer) ? this.pushAnimation.timer.cssClass : undefined
            }
        },
        isBackgroundDark() {
            return ['bg-dark', 'bg-secondary', 'bg-gray1', 'bg-gray3'].includes(this.pushAnimation.backgroundColor);
        }
    },
    mounted() {
        this.reportWindowSize();
        window.addEventListener("resize", this.reportWindowSize);
    },
    updated() {
    },
    methods: {
        reportWindowSize() {
            const pushAnimations = document.querySelectorAll(".push-animation");

            pushAnimations.forEach(function(element) {

                const textDivHeight = element.querySelector('.push-animation-text-tile').getBoundingClientRect().height + 60;
                const imageDiv = element.querySelector('.push-animation-img');

                imageDiv.style.height = "150px";
                if (window.innerWidth >= 480 && window.innerWidth <= 735) {
                    imageDiv.style.height = "200px";
                }
                if (window.innerWidth >= 736) {
                    imageDiv.style.height = textDivHeight + "px";
                }

            });
        },
    }
}
</script>

<style scoped lang="scss">
@import 'ob1_common', 'ob1_variables';

.push-animation-img {
    overflow: hidden;
    width: 100%;
    height: 150px;

    @media (min-width: #{map-get($grid-breakpoints, md)}) {
        width: 70%;
        height: 200px;
    }
    @media (min-width: #{map-get($grid-breakpoints, lg)}) {
        width: 65%;
    }
    @media (min-width: #{map-get($grid-breakpoints, xl)}) {
        width: 65%;
    }
    @media (min-width: #{map-get($grid-breakpoints, xxl)}) {
        width: 70%;
    }
}

.fill-img {
    width: 100%;
}

@media (max-width: #{map-get($grid-breakpoints, lg)}) {
    .push-animation {
        display: flex;
        -webkit-flex-wrap: wrap;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        margin-right: -15px;
        margin-left: -15px;
    }
}

.push-animation-text-tile{
    width: 100%;
}

.push-animation-text-block {

    @media (max-width: #{map-get($grid-breakpoints, md)}) {
        width: 100%;
    }
    @media (min-width: #{map-get($grid-breakpoints, md)}) {
        position: absolute;
        display: flex;
        align-items: center;
        top: 0;
        height: 100%;
        right: 0px;
        width: 60%;
    }
    @media (min-width: #{map-get($grid-breakpoints, lg)}) {
        width: 60%;
    }
    @media (min-width: #{map-get($grid-breakpoints, xl)}) {
        width: 50%;
    }
    @media (min-width: #{map-get($grid-breakpoints, xxl)}) {
        width: 50%;
    }

}

</style>
